import React from 'react';
import { Input, Button, TitleModalRight, CheckboxTable, Select } from 'components';
import { UserService, ProfileService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { connect } from 'react-redux';

interface Props extends RootState {
	title?: string;
	onClose?: any;
	item?: any;
}

class CreateUser extends React.Component<Props> {

	state = {
		form: {
			name: '',
	        email: '',
	        lastname: '',
	        position: '',
	        password: '',
	        document_type_id: Constants.DOCUMENT_TYPES.V,
	        document: '',
	        tax_document: '',
	        phone: ''
		},
		document_types: []
	}

	componentDidMount() {
		if (this.props.item) {
			this.setState({
				form: {
					...this.state.form,
					name: this.props.item?.name || '',
					email: this.props.item?.email || '',
					lastname: this.props.item?.lastname || '',
					phone: this.props.item?.phone || '',
					document: this.props.item?.document || '',
					tax_document: this.props.item?.tax_document || '',
					document_type_id: this.props.item?.document_type_id || Constants.DOCUMENT_TYPES.V
				}
			});
		}

		this.load();
	}

	load = async () => {
		const res: any = await ProfileService.get({
			user_id: this.props.item?.id || 0
		});
		this.setState({
			document_types: res.document_types
		});
	}

	submit = async (e: any) => {
		e.preventDefault();

		if (!this.state.form.document && [Constants.DOCUMENT_TYPES.V, Constants.DOCUMENT_TYPES.E].indexOf(this.state.form.document_type_id) != -1) {
			Globals.showError("El campo cédula es requerido");
			return;
		}

		if (!this.state.form.tax_document && [Constants.DOCUMENT_TYPES.J, Constants.DOCUMENT_TYPES.G].indexOf(this.state.form.document_type_id) != -1) {
			Globals.showError("El campo RIF es requerido");
			return;
		}

		if (this.props.item != null) {
			await UserService.update({
				user_id: this.props.item?.id,
				...this.state.form,
			});
			Globals.showSuccess("Se ha modificado el usuario correctamente");
			this.props.onClose();
		}
		else {
			await UserService.create({
				...this.state.form,
				owner_id: this.props.user?.id
			});
			Globals.showSuccess("Se ha creado el usuario correctamente");
			this.props.onClose();
		}
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}
	
	render() {
		return (
			<div id="create-moderator">
				<TitleModalRight
					title={ this.props.title }
					onClose={ this.props.onClose }
				/>
				<form className="container-scroll-modal-right" onSubmit={ this.submit }>
					<div className="col-md-12">
						<Input
							color="white"
							value={ this.state.form.name }
							name="name" 
							placeholder="Nombre"
							onChange={ this.change } />
					</div>
					<div className="col-md-12">
						<Input
							color="white"
							value={ this.state.form.lastname }
							name="lastname" 
							placeholder="Apellido"
							onChange={ this.change } />
					</div>
					<div className="col-md-12">
						<Input
							color="white"
							value={ this.state.form.email }
							name="email" 
							placeholder="Correo"
							onChange={ this.change } />
					</div>
					<div className="col-md-12">
						<Select
							placeholder="Tipo de Documento"
							name="document_type_id"
							onChange={ (e: any) => {
								this.setState({
									form: {
										...this.state.form,
										document_type_id: parseInt(e.target.value)
									}
								});
							} }
							value={ this.state.form.document_type_id }
							options={ this.state.document_types.map((i: any) => {
								return {
									value: i.id,
									label: i.name
								}
							}) } />
					</div>
					{
						[Constants.DOCUMENT_TYPES.V, Constants.DOCUMENT_TYPES.E].indexOf(this.state.form.document_type_id) != -1 && (
							<div className="col-md-12">
								<Input
									color="white"
									value={ this.state.form.document }
									name="document" 
									placeholder="Cédula"
									onChange={ this.change } />
							</div>
						)
					}
					{
						[Constants.DOCUMENT_TYPES.J, Constants.DOCUMENT_TYPES.G].indexOf(this.state.form.document_type_id) != -1 && (
							<div className="col-md-12">
								<Input
									color="white"
									value={ this.state.form.tax_document }
									name="tax_document" 
									placeholder="RIF"
									onChange={ this.change } />
							</div>
						)
					}
					<div className="col-md-12">
						<Input
							type="number"
							color="white"
							value={ this.state.form.phone }
							name="phone" 
							maxLength={ 11 }
							placeholder="Teléfono"
							onChange={ this.change } />
					</div>
					<div className="col-md-12">
						<Input
							type="password"
							color="white"
							value={ this.state.form.password }
							name="password" 
							placeholder={ this.props.item != null ? "Cambiar Contraseña (Opcional)" : "Contraseña" }
							onChange={ this.change } />
					</div>
					<div className="text-center">
						<Button type="submit">
							Guardar
						</Button>
					</div>
				</form>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(CreateUser);